import React, {Component} from "react";
import {HashRouter, Switch, Route} from "react-router-dom";
import {Dimmer, Loader} from "semantic-ui-react";
import Login from "./components/login";
import TopMenu from "./components/menu";
import Customers from "./routes/customers";
import Images from "./routes/images";
import Disks from "./routes/disks";
import Software from "./routes/software";
import "./app.css";


interface ISession {
    uid:    number
    name:   string
}

interface IAppState {
    loadSession:    boolean
    session:        null | ISession
}

export default class App extends Component<{}, IAppState> {
    state: IAppState = {
        loadSession:    false,
        session:        null
    }

    requestSession() {
        this.setState({loadSession:true});
        fetch('/session')
            .then(result => result.ok
                ? result.json().then(session => this.setState({session}))
                : null)
            .catch(error => alert(error))
            .finally(() => this.setState({loadSession: false}));
    }

    componentDidMount() {
        this.requestSession();
    }

    render() {
        if (this.state.loadSession)
            return (
                <Dimmer active inverted>
                    <Loader size='massive'>Loading</Loader>
                </Dimmer>
            );

        if (!this.state.session)
            return <Login onLogin={() => this.requestSession()}/>;

        return (
            <HashRouter hashType='noslash'>
                <TopMenu
                    user={this.state.session.name}
                    onClearSession={() => this.setState({session: null})}
                />
                <Switch>
                    <Route exact path='/customers' component={Customers} />
                    <Route exact path='/images' component={Images} />
                    <Route exact path='/disks' component={Disks} />
                    <Route exact path='/software' component={Software} />
                </Switch>
            </HashRouter>
        )
    }
}